/* components/labels/Label.svelte generated by Svelte v3.20.1 */
import {
	SvelteComponent,
	append,
	attr,
	check_outros,
	create_component,
	destroy_component,
	detach,
	element,
	empty,
	group_outros,
	init,
	insert,
	listen,
	mount_component,
	noop,
	safe_not_equal,
	set_data,
	set_style,
	space,
	text,
	transition_in,
	transition_out
} from "svelte/internal";

import { deleteLabel, setEditLabel, updateLabel } from "~/stores/labels";
import EditLabel from "./EditLabel";

function add_css() {
	var style = element("style");
	style.id = "svelte-134es8z-style";
	style.textContent = ".label-container.svelte-134es8z{width:25%}.buttons-container.svelte-134es8z{margin-left:auto}";
	append(document.head, style);
}

// (19:0) {#if !label.new}
function create_if_block_1(ctx) {
	let div3;
	let div0;
	let span0;
	let t0_value = /*label*/ ctx[0].name + "";
	let t0;
	let t1;
	let div1;
	let span1;
	let t2_value = /*label*/ ctx[0].description + "";
	let t2;
	let t3;
	let div2;
	let t4;
	let button;
	let dispose;
	let if_block = !/*label*/ ctx[0].editing && create_if_block_2(ctx);

	return {
		c() {
			div3 = element("div");
			div0 = element("div");
			span0 = element("span");
			t0 = text(t0_value);
			t1 = space();
			div1 = element("div");
			span1 = element("span");
			t2 = text(t2_value);
			t3 = space();
			div2 = element("div");
			if (if_block) if_block.c();
			t4 = space();
			button = element("button");
			button.textContent = "Delete";
			attr(span0, "class", "d-inline-block v-align-top px-2 py-1 rounded-1 f5 text-bold lh-condensed");
			set_style(span0, "background-color", /*label*/ ctx[0].colour);
			attr(div0, "class", "label-container svelte-134es8z");
			attr(span1, "class", "f6 text-gray");
			attr(div1, "class", "description-container");
			attr(button, "class", "link-gray btn-link ml-3 text-right");
			attr(button, "type", "button");
			attr(div2, "class", "buttons-container svelte-134es8z");
			attr(div3, "class", "Box-row border-bottom-0 m-0 d-flex flex-items-baseline");
		},
		m(target, anchor, remount) {
			insert(target, div3, anchor);
			append(div3, div0);
			append(div0, span0);
			append(span0, t0);
			append(div3, t1);
			append(div3, div1);
			append(div1, span1);
			append(span1, t2);
			append(div3, t3);
			append(div3, div2);
			if (if_block) if_block.m(div2, null);
			append(div2, t4);
			append(div2, button);
			if (remount) dispose();
			dispose = listen(button, "click", /*handleDeleteLabel*/ ctx[3]);
		},
		p(ctx, dirty) {
			if (dirty & /*label*/ 1 && t0_value !== (t0_value = /*label*/ ctx[0].name + "")) set_data(t0, t0_value);

			if (dirty & /*label*/ 1) {
				set_style(span0, "background-color", /*label*/ ctx[0].colour);
			}

			if (dirty & /*label*/ 1 && t2_value !== (t2_value = /*label*/ ctx[0].description + "")) set_data(t2, t2_value);

			if (!/*label*/ ctx[0].editing) {
				if (if_block) {
					if_block.p(ctx, dirty);
				} else {
					if_block = create_if_block_2(ctx);
					if_block.c();
					if_block.m(div2, t4);
				}
			} else if (if_block) {
				if_block.d(1);
				if_block = null;
			}
		},
		d(detaching) {
			if (detaching) detach(div3);
			if (if_block) if_block.d();
			dispose();
		}
	};
}

// (39:6) {#if !label.editing}
function create_if_block_2(ctx) {
	let button;
	let dispose;

	return {
		c() {
			button = element("button");
			button.textContent = "Edit";
			attr(button, "class", "link-gray btn-link ml-3 text-right");
			attr(button, "type", "button");
		},
		m(target, anchor, remount) {
			insert(target, button, anchor);
			if (remount) dispose();
			dispose = listen(button, "click", /*handleStartEditing*/ ctx[1]);
		},
		p: noop,
		d(detaching) {
			if (detaching) detach(button);
			dispose();
		}
	};
}

// (59:0) {#if label.editing}
function create_if_block(ctx) {
	let current;
	const editlabel = new EditLabel({ props: { label: /*label*/ ctx[0] } });
	editlabel.$on("save", /*handleSaveLabel*/ ctx[4]);
	editlabel.$on("cancel", /*handleStopEditing*/ ctx[2]);

	return {
		c() {
			create_component(editlabel.$$.fragment);
		},
		m(target, anchor) {
			mount_component(editlabel, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const editlabel_changes = {};
			if (dirty & /*label*/ 1) editlabel_changes.label = /*label*/ ctx[0];
			editlabel.$set(editlabel_changes);
		},
		i(local) {
			if (current) return;
			transition_in(editlabel.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(editlabel.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(editlabel, detaching);
		}
	};
}

function create_fragment(ctx) {
	let t;
	let if_block1_anchor;
	let current;
	let if_block0 = !/*label*/ ctx[0].new && create_if_block_1(ctx);
	let if_block1 = /*label*/ ctx[0].editing && create_if_block(ctx);

	return {
		c() {
			if (if_block0) if_block0.c();
			t = space();
			if (if_block1) if_block1.c();
			if_block1_anchor = empty();
		},
		m(target, anchor) {
			if (if_block0) if_block0.m(target, anchor);
			insert(target, t, anchor);
			if (if_block1) if_block1.m(target, anchor);
			insert(target, if_block1_anchor, anchor);
			current = true;
		},
		p(ctx, [dirty]) {
			if (!/*label*/ ctx[0].new) {
				if (if_block0) {
					if_block0.p(ctx, dirty);
				} else {
					if_block0 = create_if_block_1(ctx);
					if_block0.c();
					if_block0.m(t.parentNode, t);
				}
			} else if (if_block0) {
				if_block0.d(1);
				if_block0 = null;
			}

			if (/*label*/ ctx[0].editing) {
				if (if_block1) {
					if_block1.p(ctx, dirty);
					transition_in(if_block1, 1);
				} else {
					if_block1 = create_if_block(ctx);
					if_block1.c();
					transition_in(if_block1, 1);
					if_block1.m(if_block1_anchor.parentNode, if_block1_anchor);
				}
			} else if (if_block1) {
				group_outros();

				transition_out(if_block1, 1, 1, () => {
					if_block1 = null;
				});

				check_outros();
			}
		},
		i(local) {
			if (current) return;
			transition_in(if_block1);
			current = true;
		},
		o(local) {
			transition_out(if_block1);
			current = false;
		},
		d(detaching) {
			if (if_block0) if_block0.d(detaching);
			if (detaching) detach(t);
			if (if_block1) if_block1.d(detaching);
			if (detaching) detach(if_block1_anchor);
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let { label } = $$props;
	let nameInput = label.name;
	let descriptionInput = label.description;
	const handleStartEditing = () => setEditLabel(label.id, true);
	const handleStopEditing = () => setEditLabel(label.id, false);
	const handleDeleteLabel = () => deleteLabel(label.id);

	const handleSaveLabel = event => {
		const newId = updateLabel(label.id, event.detail);
		setEditLabel(newId, false);
	};

	$$self.$set = $$props => {
		if ("label" in $$props) $$invalidate(0, label = $$props.label);
	};

	return [
		label,
		handleStartEditing,
		handleStopEditing,
		handleDeleteLabel,
		handleSaveLabel
	];
}

class Label extends SvelteComponent {
	constructor(options) {
		super();
		if (!document.getElementById("svelte-134es8z-style")) add_css();
		init(this, options, instance, create_fragment, safe_not_equal, { label: 0 });
	}
}

export default Label;